import React, { FC, ReactElement } from 'react'

import { ConnectedDateNavigator } from '../../connectors'
import { ScheduleShift } from '../../entities/Shift/Shift'
import { TimeModeType } from '../../types/timeModeTypes'
import Days from './subcomponents/Days/Days'

import './Calendar.scss'

export interface CalendarProps {
    isLoading: boolean
    days: Date[]
    shifts: ScheduleShift[]
    timeMode: TimeModeType
    className?: string
}

export const Calendar: FC<CalendarProps> = ({
    isLoading,
    days,
    shifts,
    timeMode,
    className = '',
}) => {
    const renderDays = (selectedDays: Date[], showHeader = true): ReactElement => (
        <Days
            shifts={shifts}
            showHeader={showHeader}
            selectedDays={selectedDays}
            isLoading={isLoading}
            mode={timeMode}
        />
    )

    return (
        <div className={`calendar ${className}`}>
            <ConnectedDateNavigator
                timeModeButtons={[TimeModeType.week]}
                onAfterDateChange={() => {}}
                className="calendar__navigator"
            />

            <div className="calendar__days">
                {renderDays(days)}
            </div>
        </div>
    )
}
